import React, {Component,Fragment} from 'react';
import PropTypes from 'prop-types'
import NotificationSystem from 'react-notification-system';
import moment from 'moment';
import {BeatLoader} from 'react-spinners';
import StepZilla from "react-stepzilla";
import {_addNotification,_addNotificationError} from '../../server/util';
import {lunchBreakfastModal,personModal,personType,incomeModal, IncomFreqency}from '../Parent/SchoolLunchBreakfastProgram/schoolLunchBreakfastModal'
import {BASE_URL} from "../../server/constants"
import {get, postWithHeaders, patch} from "../../server/actions";
import Select,{components} from 'react-select';
import makeAnimated from 'react-select/animated';
import Welcome from '../Parent/SchoolLunchBreakfastProgram/welcome';
import W_FirstParentInfo from './w_firstParentInfo';
import W_SchoolSelect from './w_selectStudent'
import AssistanceProgram from './assistancePrograms';
import FosterQualify from './fosterQualify';
import MigrantQualify from './migrantQualify';
import IncomeOption from './incomeOption';
import AddChild from './addChild';
import AddAdult from './addAdult';
import AddChildIncome from './addChildIncome';
import AddAdultIncome from './addAdultIncome';
import AddressDetails from './addressDetails';
import RacialEthnic from './racialEthnic';
import SSN from './ssn';
import Agreement from './agreement';
import W_summaryReport from './w_summaryReport'; 
import FreeReducedProgramFAQ from '../Parent/SchoolLunchBreakfastProgram/freeReducedProgramFAQ'
import StepFinal from './stepFinal';
import {Link} from 'react-router-dom';
import logo from '../../assets/img/logo1.png';
import './faqSidepan.css'
import BeforeBegin from '../Parent/SchoolLunchBreakfastProgram/beforeBegin';
import { createFilter } from 'react-select/dist/react-select.cjs.prod';
import { Placeholder } from 'react-select/animated/dist/react-select.cjs.prod';
import AppFooter from '../Misc/AppFooter';
import { translate, Trans} from "react-i18next";

const animatedComponents = makeAnimated();
const appHeader=(props)=>{
    return (
        <div>
            <header id="pageTop" className="header-wrapper">
                <div className="container-fluid color-bar top-fixed clearfix">
                    <div className="row">
                        <div className="col-sm-1 col-xs-2 bg-color-1">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-2">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-3">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-4">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-5">fix bar</div>
                        <div className="col-sm-1 col-xs-2 bg-color-6">fix bar</div>
                        <div className="col-sm-1 bg-color-1 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-2 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-3 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-4 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-5 hidden-xs">fix bar</div>
                        <div className="col-sm-1 bg-color-6 hidden-xs">fix bar</div>
                    </div>
                </div>
                <nav id="menuBar" className="navbar navbar-default lightHeader">
                <div className="container">
                    <div className="navbar-header">                  
                        <a className="navbar-brand" id="brand" href="https://www.mealmanage.com"><img className="super-admin-logo"
                                                                                            src={logo} alt="www.mealmanage.com"/></a>
                        
                    </div>
                    <div className="navbar-collapse collapse" id="navbar">
                            <ul className="nav navbar-nav navbar-right" style={{height: 'auto'}}>
                                <li className=" dropdown color-1 active ">
                                    <a>                                   
                                <span role="button" aria-haspopup="true" aria-expanded="false" onClick={()=>{
                                        props.showHidefaqsidebar()
                                    }}><Trans>Help</Trans></span></a>
                                </li>
                            </ul>
                        </div>
                   
                                        
                </div>
            </nav>
            </header>
        </div>
    )

}
class FreeReducedProgram extends Component {
  constructor(props) {
    super(props)
    this.state={
      schoolList:[],
        loading:false,
        initStep:0,
        showStepWizard:false,
        districtStatus:false,
        appliedStudents:[],
        lunchBreakfastObj: JSON.parse(JSON.stringify(lunchBreakfastModal)),
        schoolInfo:{id:0,name:'',sessionYear:'',schoolPdfUrl:'', schoolYearValue:''},
        showDropDown:false,
        inPermId:0,
        inPermType:''
    }
    this.buildSchoolList=this.buildSchoolList.bind(this);
}
initData=()=>{
    const {id,type}= this.props.match.params;
    const {districtStatus}=this.state;
    if(type==='SCHOOL'){
        this.buildSchoolList();
    }else if(type==='DIST'){
        this.buildDistrictList();
    }else if(type==='PARENT'){
        this.buildSchoolsByParent();        
    }else{
        if(districtStatus){
            this.buildDistrictList();

        }else{
            this.buildSchoolList();
        }
        
    }
}
componentDidMount=()=>{
  this._notificationSystem = this.refs.notificationSystem;
  //index.html keeps overflow-y hidden on <html> because the logged in pages scroll inside
  //their own fixed height container. This application grows with the household size, so it
  //needs the page itself to scroll, otherwise Continue/Save As Draft fall out of reach.
  document.documentElement.style.overflowY='auto';
  this.initData();
}
componentWillUnmount=()=>{
  document.documentElement.style.overflowY='hidden';
}
buildDistrictList=()=>{
    const {id,type}= this.props.match.params;
     const url=BASE_URL+"/website/districtInfo?currentDate="+moment().format('YYYY-MM-DD');
     this.setState({loading:true, schoolList:[]});
       fetch(url).then((response) => {
         if (!response.ok) {
             throw Error(response.statusText);
         }
         console.log('response', response);
         return response.json();
     }).then(data => {
    //    this.setState({schoolList:data.map(rec=>{
    //     return {schoolName:rec.districtName,schoolId:rec.districtId}
    //    }), loading:false})   
         console.log('schoolList',data)
    if(type==='DIST'){
        const selectedSchool= (data||[]).find(sch=>{
             return sch.districtId==id;
         });
         if(selectedSchool){
             let _districtInfo={};
             _districtInfo.id=Number(selectedSchool.districtId);
             _districtInfo.name=selectedSchool.districtName;
            //  _districtInfo.sessionYear=selectedSchool.schoolYear||'';
            //  _districtInfo.schoolPdfUrl=selectedSchool.schoolPdfUrl||'';
             this.setState({schoolList:data, loading:false, schoolInfo:_districtInfo,  districtStatus:true, showStepWizard:true});
         }else{
             this.setState({schoolList:data, loading:false,  districtStatus:true, showStepWizard:false});
         }       
 
     }else{
         //this.setState({schoolList:data, loading:false});
         this.setState({schoolList:data.map(rec=>{
                return {schoolName:rec.districtName,schoolId:rec.districtId}
               }), loading:false}) 
     }
     }).catch(
             (error) => {
                 //_addNotificationError('Activation failed. Please try again later', this);
                 console.log('already applied students', error);             
                 this.setState({schoolList:[], loading:false});
             }
         ); 
   }
   buildSchoolsByParent=()=>{
    const {id}= this.props.match.params;
    this.setState({loading:true, schoolList:[]});
    const url=BASE_URL+"/website/studentsInfoByParentId?parentEmail="+id
    fetch(url).then((response) => {
      if (!response.ok) {
          throw Error(response.statusText);
      }
      console.log('response', response);
      return response.json();
  }).then(data => {  
    const {districtStatus}=this.state; 
    if(districtStatus) {
        const distName=[];
        const districts=[];        
        ((data||{}).resp||[]).map(sch=>{    
            if(! distName.includes(sch.districtName))  {
                const _schoolInfo={};
                distName.push(sch.districtName);
                _schoolInfo.schoolName=sch.districtName;
                _schoolInfo.schoolId=sch.districtId;
                districts.push(_schoolInfo) ;
            }  
        });
        this.setState({schoolList:districts||[], loading:false,  districtStatus:true, showStepWizard:false});
    }else{
        const schoolName=[];
        const schools=[];
        ((data||{}).resp||[]).map(sch=>{    
        if(! schoolName.includes(sch.schoolName))  {
            const _schoolInfo={};
            schoolName.push(sch.schoolName);
            _schoolInfo.schoolId=Number(sch.schoolId);
            _schoolInfo.schoolName=sch.schoolName;
            _schoolInfo.schoolYear=sch.schoolYear||'';
            _schoolInfo.schoolYearValue=sch.schoolYearValue||'';
            _schoolInfo.schoolPdfUrl=sch.schoolPdfUrl||'';
            schools.push(_schoolInfo) ;
        }   
            
        });
        this.setState({schoolList:schools||[], loading:false,  districtStatus:false, showStepWizard:false});
    }
  }).catch(
          (error) => {
              //_addNotificationError('Activation failed. Please try again later', this);
              console.log('already applied students', error);             
              this.setState({schoolList:[],loading:false});
          }
      ); 
}
buildSchoolList=()=>{
    const {id,type}= this.props.match.params;
 this.setState({loading:true, schoolList:[]});
  const url=BASE_URL+"/website/onboardedSchools?currentDate="+moment().format('YYYY-MM-DD')
    fetch(url).then((response) => {
      if (!response.ok) {
          throw Error(response.statusText);
      }
      console.log('response', response);
      return response.json();
  }).then(data => {
    console.log('schoolList1',data)
    if(type==='SCHOOL'){
       const selectedSchool= (data||[]).find(sch=>{
            return sch.schoolId==id;
        });
        if(selectedSchool){
            let _schoolInfo={};
            _schoolInfo.id=Number(selectedSchool.schoolId);
            _schoolInfo.name=selectedSchool.schoolName;           
            _schoolInfo.sessionYear=selectedSchool.schoolYear||'';
            _schoolInfo.schoolYearValue=selectedSchool.schoolYearValue||'';
            _schoolInfo.schoolPdfUrl=selectedSchool.schoolPdfUrl||'';
            this.setState({schoolList:data, loading:false, schoolInfo:_schoolInfo,  districtStatus:false, showStepWizard:true});
        }else{
            this.setState({schoolList:data, loading:false,  districtStatus:false, showStepWizard:false});
        }       

    }else{
        this.setState({schoolList:data, loading:false});
    }
  }).catch(
          (error) => {
              //_addNotificationError('Activation failed. Please try again later', this);
              console.log('already applied students', error);             
              this.setState({schoolList:[],loading:false});
          }
      ); 
}
buildApplicationUI=(content, appData, trans)=>{
    if(Object.keys(appData).length>0){
    let mainDev=document.createElement('div');
    let title=document.createElement('div');
    let heading=document.createElement('h3');
    heading.innerHTML=trans("Household Application for Free and Reduced Price School Meals");
    heading.style.color='red';
    heading.style.textAlign='center';
    title.appendChild(heading);
    mainDev.appendChild(title);

    let appNo_date=document.createElement('div');
    let leftDiv=document.createElement('div');
    leftDiv.style.cssFloat='left';
    leftDiv.style.maxWidth='50%';
    leftDiv.innerHTML='<p><strong>'+trans('Application Id')+':</strong></p>';
    appNo_date.appendChild(leftDiv);

    let rightDiv=document.createElement('div');
    rightDiv.style.cssFloat='right';
    rightDiv.style.textAlign='right';
    rightDiv.style.maxWidth='50%';
    rightDiv.innerHTML='<p>'+trans('Date')+': <strong>'+moment(appData.date,'MMDDYYYY').format('MM-DD-YYYY')+'</strong></p>';
    appNo_date.appendChild(rightDiv);
    mainDev.appendChild(appNo_date);

    let childDiv=document.createElement('div');
    let childTable='<table width="100%" border=1 style="border-collapse: collapse; border: 1px solid #ddd; font-size:12px">';
    let childHead='<thead><tr>'+
            '<th rowspan="2" style="width:20%">'+trans('First Name')+'</th>'+
            '<th rowspan="2" style="width:20%">'+trans('Last Name')+'</th>'+
            '<th rowspan="2" style="width:7%">'+trans('Grade')+'</th>'+
            '<th colspan="2" style="width:15%">'+trans('Student?')+'</th>'+
            '<th rowspan="2" style="width:10%">'+trans('Foster Child')+'</th>'+
            '<th rowspan="2" style="width=10%">'+trans('Runaway Program')+'</th>'+
            '<th rowspan="2" style="width=10%">'+trans('McKinney-Vento Homeless')+'</th>'+
            '<th rowspan="2" style="width=10%">'+trans('Migrant Education Program')+'</th>'+
            '<th rowspan="2" style="width=10%">'+trans('Head Start')+'</th>'+
            '</tr><tr>'+
            '<th>'+trans('Yes')+'</th>'+
            '<th>'+trans('No')+'</th>'+
            '</tr></thead>';
    let childStudents='';
    (appData.householdAppInfo||[]).map((student)=>{
            if(student.personType===personType.student){
               /*  let homelessString='';
                if( student.runaway){
                    (student.homelessOrMigrantOrRunawayOptions||[]).map(itm=>{
                        homelessString=homelessString+ '<span>&#10003;</span> <span>'+itm+'</span><br />';
                    });
                } */
                childStudents=childStudents+'<tr><td>'+student.fname+'</td>'+
                '<td>'+student.lname+'</td>'+
                '<td>'+student.grade+'</td>'+
                '<td style="text-align:center">'+(student.personType===personType.student?'<span>&#10003;</span>':'')+'</td>'+
                '<td style="text-align:center">'+(student.personType!==personType.student?'<span>&#10003;</span>':'')+'</td>'+
                '<td style="text-align:center">'+(student.liveUnderFosterCare?'<span>&#10003;</span>':'')+'</td>'+
                '<td style="text-align:center">'+(student.runaway?'<span>&#10003;</span>':'')+'</td>'+
                '<td style="text-align:center">'+(student.mcKinneyVentoHomeless?'<span>&#10003;</span>':'')+'</td>'+
                '<td style="text-align:center">'+(student.migrantEducationPrg?'<span>&#10003;</span>':'')+'</td>'+
                '<td style="text-align:center">'+(student.headStart?'<span>&#10003;</span>':'')+'</td></tr>';
            }
    });
    let childs='';
    (appData.householdAppInfo||[]).map((student)=>{
        if(student.personType===personType.child){
           /*  let homelessString='';
                if( student.runaway){
                    (student.homelessOrMigrantOrRunawayOptions||[]).map(itm=>{
                        homelessString=homelessString+ '<span>&#10003;</span> <span>'+itm+'</span><br />';
                    });
                } */
            childs=childs+'<tr><td>'+student.fname+'</td>'+
            '<td>'+student.lname+'</td>'+
            '<td>'+student.grade+'</td>'+
            '<td style="text-align:center">'+(student.personType===personType.student?'<span>&#10003;</span>':'')+'</td>'+
            '<td style="text-align:center">'+(student.personType!==personType.student?'<span>&#10003;</span>':'')+'</td>'+
            '<td style="text-align:center">'+(student.liveUnderFosterCare?'<span>&#10003;</span>':'')+'</td>'+
            '<td style="text-align:center">'+(student.runaway?'<span>&#10003;</span>':'')+'</td>'+
            '<td style="text-align:center">'+(student.mcKinneyVentoHomeless?'<span>&#10003;</span>':'')+'</td>'+
            '<td style="text-align:center">'+(student.migrantEducationPrg?'<span>&#10003;</span>':'')+'</td>'+
            '<td style="text-align:center">'+(student.headStart?'<span>&#10003;</span>':'')+'</td></tr>';
        }
    });
    let programDev=document.createElement('div');
    let programLbl='<p style="font-size: 12px;"><strong>'+trans('Do any Household Members (including you) currently participate in one or more of the following assistance programs')+': SNAP, TANF, or FDPIR?'+'</strong></p>'+'<table width="100%" border=1 style="border-collapse: collapse; border: 1px solid #ddd; font-size:12px">';
    let programList='';
    ((appData.householdAppInfo[0]||{}).assistancePrograms||[]).map((program,p)=>{
        programList=programList+'<tr style="font-size: 12px;"><td style="width:50%"><strong>'+trans(program.name)+' :</strong></td><td><label>'+program.caseNumber+'</label></td></tr></tr>'
    })
    programDev.innerHtml=programLbl+programList+'</table>';
    
    let incomeDev=document.createElement('div');  

    let incomeBody='';
    let isIncomeExist=(appData.householdAppInfo||[]).some((person)=>{
        return person.income.length>0;
    });
    if(isIncomeExist){
        let incomeHeader='<p style="font-size:14px;  margin:5px 0px;"><strong>'+trans('Report Income for ALL Household Members')+'</strong></p><table width="100%" border=1 style="border-collapse: collapse; border: 1px solid #ddd; font-size:12px">'+
    '<tr><th rowspan="2">'+trans('Name')+'</th><th colspan="3" style="text-align:center;">'+trans('Income') +'($)</th></tr><tr><th>'+trans('Source')+'</th><th>'+trans('Frequency')+'</th><th>'+trans('Amount')+ '($)</th></tr>';
        appData.householdAppInfo.map((person)=>{
            if(person.income.length>0){
                incomeBody=incomeBody+'<tr><td rowspan='+(person.income.length+1)+'>'+person.fname+' '+person.lname+'</td><td colspan="3" style="padding:0; border:0;"></td></tr>'
                person.income.map(income=>{
                    incomeBody=incomeBody+'<tr><td>'+income.source+'</td><td>'+ this.getFrequencyName(income.frequency)+'</td><td>'+income.amount+'</td></tr>' 
                })
            }
        })
        incomeDev.innerHTML=incomeHeader+'<tbody>'+incomeBody+'</tbody>'+'</table>';
    }
    let addressDev='<p style="font-size:14px;  margin:5px 0px;"><strong>'+trans('Contact information')+'</strong></p>'+
    '<div class="table-responsive"><table width="100%" style="font-size:12px"><tr><td><span><strong>'+trans('Email')+ ':</strong></span><span> '+appData.householdAppInfo[0].contact.email+
    '</span></td><td><span><strong>'+trans('Phone')+ ':</strong></span><span> '+appData.householdAppInfo[0].contact.phone+
    '</span></td><td><span><strong>'+trans('Address 1')+ ':</strong></span><span> '+appData.householdAppInfo[0].contact.street1+'</span></td></tr>'+
    '<tr><td><span><strong>'+trans('Address 2')+ ':</strong></span><span> '+appData.householdAppInfo[0].contact.street2+
    '</span></td><td><span><strong>'+trans('City')+ ':</strong></span><span> '+appData.householdAppInfo[0].contact.city+'</span></td>'+
    '<td><span><strong>'+trans('State')+ ':</strong></span><span> '+appData.householdAppInfo[0].contact.state+'</span></td></tr>'+
    '<tr><td><span><strong>'+trans('Zip')+ ':</strong></span><span> '+appData.householdAppInfo[0].contact.zip+'</span></td><td></td><td></td></tr>'+
    '</table></div>';
    let ssnDev='<p style="font-size:12px"><strong>'+trans('Last Four Digits of Social Security Number (SSN) of Primary Wage Earner or Other Adult Household Member')+'</strong>'+
    ': '+(appData.householdAppInfo[0].noSSN===true? 'No SSN': appData.householdAppInfo[0].ssn)+'</p>';

    let racialDev="<p style='font-size:14px;  margin:5px 0px;'><strong>"+trans("Children's Racial and Ethnic Identities")+"</strong></p>";
    racialDev=racialDev+'<table border=1 width="100%" style="border-collapse: collapse; border: 1px solid #ddd;font-size:12px"><tr><th style="width:25%">'+trans('Name')+'</th><th style="width:25%">'+trans('Ethnicity')+'</th><th>'+trans('Race')+'</th></tr>'
    appData.householdAppInfo.map((student)=>{
        if(student.personType===personType.student){
            racialDev=racialDev+'<tr><td>'+student.fname+' '+student.lname+
            '</td><td>'+(student.ethenticity||"")+'</td><td>'+(student.race||[]).join(', ')+'</td></tr>';
        }
    });
    racialDev=racialDev+'</table>';
    //let houseHoldDiv= this.getTotalIncome(appData.householdAppInfo)>0?('<p style="font-size:12px; margin:5px 0px;"><span><strong>Total Household Income per Annum ($) : </strong></span><span>'+this.getTotalIncome(appData.householdAppInfo)+'</sp></p>'):''+ '';
    // '<p style="font-size:12px; margin:5px 0px;"><span><strong>Total Household Size : </strong></span><span>'+appData.householdAppInfo.length+'</span></p>';
    
    let applicentDev='<div style="padding:10px; float:right"><p style="text-align:left;margin: 2; padding-bottom:5px;padding-top:10px; font-size: 14px;">'+trans('Submitted By')+',</p>'+
    '<strong style="text-align: left;display: block;font: 16px bold;text-transform: uppercase;">'+appData.householdAppInfo[0].fname+' '+appData.householdAppInfo[0].lname+'</stro>'
    +'<span style="text-align: left;display: block;font: 13px italic;">'+trans('Date')+':'+moment(appData.date,'MMDDYYYY').format('YYYY-MM-DD HH:MM:SS')+'</span></div>'
    childDiv.innerHTML=childTable+childHead+
    '<tbody>'+childStudents+childs+
    '</tbody></table>'+programDev.innerHtml+incomeDev.innerHTML+
    addressDev+ssnDev+racialDev+
    //houseHoldDiv+
    applicentDev;
    mainDev.appendChild(childDiv);

    content.innerHTML = mainDev.outerHTML;
}
}
getFrequencyName=(freq)=>{
    let frequency= IncomFreqency.find(inf=>{
         return inf.value==freq;
     });
     return((frequency||{}).text||'');
 }
 getAnnualIncome=(Income)=>{
    let amount=0.00;
    Income.map(inc=>{
        amount=amount+(parseInt(inc.frequency)* parseFloat(inc.amount))
    });    
    return amount;
}
getTotalIncome=(students)=>{
    let amount=0.00;
    students.map((student)=>{
        amount=amount+this.getAnnualIncome(student.income);
    });
    return amount
}

showHidefaqsidebar=()=>{
    let myButtonClasses = document.getElementById("faqsidebar").classList;
    if (myButtonClasses.contains("active")) {
        myButtonClasses.remove("active");                                    
    } else {                                    
        myButtonClasses.add("active");                                    
    }
}
hideMenu=()=>{
    this.setState({showDropDown:false});
}

updateLunchObj = (newData) => {
    this.setState({ lunchBreakfastObj: newData });
  }

    render(){
        const { t, i18n } = this.props;
        const changeLanguage = lng => {
          i18n.changeLanguage(lng);
        };
        const {districtStatus}=this.state;
      const steps =[        
        {name:'Welcome',component:<Welcome schoolInfo={{...this.state.schoolInfo,districtStatus}} />},
        {name:'Before you begin', component:<BeforeBegin schoolInfo={{...this.state.schoolInfo,districtStatus}} schoolList={this.state.schoolList} />},
        {name:'Parent Info', component:<W_FirstParentInfo lunchObj={this.state.lunchBreakfastObj} 
        schoolInfo={{...this.state.schoolInfo,districtStatus}} 
        updateLunchObj={this.updateLunchObj}
        setLoader={(status)=>{
            this.setState({loading:status});
        }}
        onSubmitParentForm={(data,callback)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj
            _lunchBreakfastObj=data;
            this.setState({lunchBreakfastObj:_lunchBreakfastObj},()=>{
                callback()
            })
        }}
            onApplicantFieldChange={(key,value)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj
                _lunchBreakfastObj.persons[0][key]=value;
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            }}
        />},
        {name:'Students', component:<W_SchoolSelect lunchObj={this.state.lunchBreakfastObj} schoolInfo={{...this.state.schoolInfo,districtStatus}} allStudentList={this.state.lunchBreakfastObj.studentList} draftData={this.props.draftData} 
            onStudentSelectChange={(index,status)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj
                _lunchBreakfastObj.studentList[index].isSelected=status;
                this.setState({lunchBreakfastObj:_lunchBreakfastObj}) 
            }}
        />},
        {name:"Assistance Programs", component:<AssistanceProgram lunchObj={this.state.lunchBreakfastObj} schoolInfo={{...this.state.schoolInfo,districtStatus}}
            onProgramSelectChange={(index,status)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj
                    _lunchBreakfastObj.assistancePrograms[index].isApplicable=status;
                    if(!status){
                        _lunchBreakfastObj.assistancePrograms[index].caseNumber='';
                    }
                    this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            }} onProgramCardNoChanged={(index,value)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj
                    _lunchBreakfastObj.assistancePrograms[index].caseNumber=value;
                    this.setState({lunchBreakfastObj:_lunchBreakfastObj});
            }} /> },
        {name:'Foster Qualify', component:<FosterQualify lunchObj={this.state.lunchBreakfastObj} schoolInfo={{...this.state.schoolInfo,districtStatus}}
            onAllFosterSelectChange={(key,status)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj
            _lunchBreakfastObj[key]=status;
            if(status===false){
                    _lunchBreakfastObj.studentList.map((stu,i)=>{
                    if(stu.isSelected===true){
                        _lunchBreakfastObj.studentList[i].liveUnderFosterCare=false
                    }
                });
            }                   
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})
            }}
            onStudentFasterSelectChange={(index,status)=>{
                let _lunchBreakfastObj=this.state.lunchBreakfastObj
                _lunchBreakfastObj.studentList[index].liveUnderFosterCare=status;
                this.setState({lunchBreakfastObj:_lunchBreakfastObj}) 
            }}
        />},
        {name:'Migrant Qualify', component:<MigrantQualify lunchObj={this.state.lunchBreakfastObj}
        schoolInfo={{...this.state.schoolInfo,districtStatus}}
        onMcKinneyVentoProgramStatusChange={(index,status)=>{ 
            let _lunchBreakfastObj=this.state.lunchBreakfastObj
                _lunchBreakfastObj.studentList[index].mcKinneyVentoHomeless=status;
                
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }} 
        onMigrantEducationStatusChange={(index,status)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj
                _lunchBreakfastObj.studentList[index].migrantEducationPrg=status;
                
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }} 
        onStudentMigrantStatusChange={(index,status)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj
                _lunchBreakfastObj.studentList[index].runaway=status;

                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }}
        onHeadStartStatusChange={(index,status)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj
                _lunchBreakfastObj.studentList[index].headStart=status;

                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }} />},
        {name:'Income Option', component:<IncomeOption lunchObj={this.state.lunchBreakfastObj}
        schoolInfo={{...this.state.schoolInfo,districtStatus}}
         onSelectionChange={(key,status)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj
                _lunchBreakfastObj[key]=status;
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
         }} />},
        {name:'Add Child', component:<AddChild lunchObj={this.state.lunchBreakfastObj} 
        schoolInfo={{...this.state.schoolInfo,districtStatus}} onAddNewChild={()=>{
            let newChild=JSON.parse(JSON.stringify(personModal))
            newChild.personType=personType.child;
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            _lunchBreakfastObj.childList.push(newChild);
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }} onDeleteChild={(index)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            _lunchBreakfastObj.childList.splice(index, 1);
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})

        }} onFieldValueChange={(index,key,value)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            _lunchBreakfastObj.childList[index][key]=value;
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }} />},            
        {name:'Add Child Income', component:<AddChildIncome lunchObj={this.state.lunchBreakfastObj}
        schoolInfo={{...this.state.schoolInfo,districtStatus}} 
        onFieldValueChange={(mainIndex,mainKey,subindex,subKey,value)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            _lunchBreakfastObj[mainKey][mainIndex].income[subindex][subKey]=value;
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }}
        addIncome={(mainIndex,mainKey)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            _lunchBreakfastObj[mainKey][mainIndex].income.push(Object.assign({},incomeModal));
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }}
        onDeleteIncome={(mainIndex,mainKey,subIndex)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            _lunchBreakfastObj[mainKey][mainIndex].income.splice(subIndex,1);
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }}
        />},
        {name:'Add Adult', component:<AddAdult lunchObj={this.state.lunchBreakfastObj}
        schoolInfo={{...this.state.schoolInfo,districtStatus}}
        onAddNewAdult={()=>{
            let newAdult=JSON.parse(JSON.stringify(personModal))
            newAdult.personType=personType.adult;
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            _lunchBreakfastObj.adultList.push(newAdult);
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }} onDeleteAdult={(index)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            _lunchBreakfastObj.adultList.splice(index, 1);
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})

        }} onFieldValueChange={(index,key,value)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            _lunchBreakfastObj.adultList[index][key]=value;
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }}
         />},
        {name:'Add Adult Income', component:<AddAdultIncome 
        schoolInfo={{...this.state.schoolInfo,districtStatus}}
        lunchObj={this.state.lunchBreakfastObj}
        onFieldValueChange={(mainIndex,mainKey,subindex,subKey,value)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            _lunchBreakfastObj[mainKey][mainIndex].income[subindex][subKey]=value;
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }}
        addIncome={(mainIndex,mainKey)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            _lunchBreakfastObj[mainKey][mainIndex].income.push(Object.assign({},incomeModal));
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }}
        onDeleteIncome={(mainIndex,mainKey,subIndex)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            _lunchBreakfastObj[mainKey][mainIndex].income.splice(subIndex,1);
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }}  />},
        {name:'Address Details', component:<AddressDetails lunchObj={this.state.lunchBreakfastObj}
        schoolInfo={{...this.state.schoolInfo,districtStatus}}
        onAddressChange={(key,value)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj
                _lunchBreakfastObj.persons[0].contact[key]=value;
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }} />},
        {name:'Racial & Ethnic', component:<RacialEthnic lunchObj={this.state.lunchBreakfastObj}
        schoolInfo={{...this.state.schoolInfo,districtStatus}}
        onEthnicChange={(index,key,status)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj
                _lunchBreakfastObj.studentList[index][key]=status;
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }} onRacialChange={(index,value,status)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj;
            let raceArray=[]
            if(_lunchBreakfastObj.studentList[index].race.length>0){
                raceArray=_lunchBreakfastObj.studentList[index].race;
            }                
            if(_lunchBreakfastObj.studentList[index].race.includes(value)){                    
                var idx = raceArray.indexOf(value);
                if (idx > -1) {
                     raceArray.splice(idx, 1);
                }          
            }
            if(status){
                raceArray.push(value);
            }  
            _lunchBreakfastObj.studentList[index].race=raceArray              
            this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }} />},
        {name:'SSN', component:<SSN lunchObj={this.state.lunchBreakfastObj} schoolInfo={{...this.state.schoolInfo,districtStatus}}
        onSSNChange={(key,value)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj
                _lunchBreakfastObj.persons[0][key]=value;
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }} onNoSSNChange={(key,status)=>{
            let _lunchBreakfastObj=this.state.lunchBreakfastObj
                _lunchBreakfastObj.persons[0][key]=status;
                this.setState({lunchBreakfastObj:_lunchBreakfastObj})
        }}  />},
        {name:'Agreement', component:<Agreement lunchObj={this.state.lunchBreakfastObj} refNotify={this} 
        schoolInfo={{...this.state.schoolInfo,districtStatus}} />},
         {name:'Summery', component:<W_summaryReport lunchObj={this.state.lunchBreakfastObj} refNotify={this} 
         schoolInfo={{...this.state.schoolInfo,districtStatus}} buildHtmlUI={(ele,appObj)=>{
                this.buildApplicationUI(ele,appObj,t);
            }} />},
        {name:"Final", component:<StepFinal />}
      ];
        return(<Fragment>
                {appHeader(this)}
                <NotificationSystem ref="notificationSystem"/>
                <div style={{overflowY: "auto", overflowX: "hidden",
                        height: "calc(100vh - 140px)",
                }}>
                <div className="main-wrapper" style={{marginTop:'10px'}}>
                    <section className="mainContent full-width clearfix" style={{minHeight:'calc(100vh - 180px)', boxSizing:'border-box'}}>
                        <div className='sweet-loading' style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                            <BeatLoader
                                size={20}
                                color={'#ea7066'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="container">
                            <div className='row'>
                                <div className='col-xs-12 col-sm-12 col-md-2 pull-right'>
                                    <label ><Trans>Language</Trans> :</label>
                                    <select className='form-control form-control-sm' value={i18n.language} onChange={(e)=>{
                                        if((e.target.value||'')==''){
                                            changeLanguage('en');
                                        }
                                        else{
                                            changeLanguage(e.target.value);
                                        }
                                    }}>
                                        <option value={'en'}>English</option>
                                        <option value={'es'}>Spanish</option>
                                    </select>
                                </div>
                            </div>
                        <div className="sectionTitle">
                                <h2><span><Trans>Free and Reduced Meal Eligibility Application</Trans></span></h2>
                            </div>                           
                            <div className="row">
                                <div className="col-md-12">
                                {
                                    this.state.showStepWizard?
                                    (
                                        <div className="row">                              
                                            <div className="col-xs-12">
                                                    <StepZilla steps={steps} 
                                                                showNavigation={false}
                                                                nextButtonCls= "btn btn-prev btn-xs bg-color-2 pull-right"
                                                                backButtonCls= "btn btn-next bg-color-4 btn-xs pull-left"
                                                                nextTextOnFinalActionStep= "Save"
                                                                nextButtonText= "Continue"
                                                                prevBtnOnLastStep={false} 
                                                                startAtStep={0}
                                                                showSteps={false}
                                                                preventEnterSubmission
                                                               /*  onStepChange={(e)=>{
                                                                    if(e===4){
                                                                        if(this.state.lunchBreakfastObj.studentList.length<=0){
                                                                            return false;

                                                                        }
                                                                    }
                                                                    console.log(e)

                                                                }} */
                                                                />
                                                </div>                                                            
                                            </div>
                                    ):
                          (<div className="row">
                            <div className="col-xs-12 form-group">
                                <div className="styled-input-single col-md-5 pull-left"
                                    style={{margin: '-15px 8px'}}>
                                    <input type="checkbox" name="districtStatus"
                                        onChange={(e)=>{
                                            const isChecked=e.target.checked
                                            this.setState({districtStatus:e.target.checked},()=>{
                                                this.refSchoolSelect.select.clearValue();
                                                let _schoolInfo=this.state.schoolInfo;
                                                _schoolInfo.id=0;
                                                _schoolInfo.name='';
                                                _schoolInfo.sessionYear='';
                                                _schoolInfo.schoolPdfUrl='';
                                                this.setState({schoolInfo:_schoolInfo})
                                                if(isChecked){
                                                    //this.buildDistrictList()
                                                    this.initData();
                                                }else{
                                                    //this.buildSchoolList();
                                                    this.initData();
                                                }
                                            })
                                        }}
                                        id={'districtStatus'}
                                        checked={this.state.districtStatus?true:false}
                                    />
                                    <label  htmlFor={'districtStatus'}><Trans>Please check here to apply Family Application</Trans></label>
                                </div>

                            </div>  
                          
                          <div className="col-xs-12 form-group">
                            <div style={{fontSize: '14px', padding: '8px'}}>
                               <Trans>{`Please Search For The ${this.state.districtStatus?'District':'School'} And Click`}</Trans> <span style={{background:'#5cb85c', color: '#fff', fontWeight: 'bold', padding: '3px'}}>→</span>  <Trans>{`To Get Started With Application`}</Trans>
                                </div>
                            </div>                          
                          <div className="col-xs-12 col-md-7  form-group">
                            <Select ref={(c)=>this.refSchoolSelect=c} 
                                placeholder={<div><Trans>{`Enter ${this.state.districtStatus?'District':'School'} Name`}</Trans></div>}
                            components={({ children, ...props }) => (
                                <components.Control {...props}>
                                 {children}
                                </components.Control>
                              )}
                                filterOption={createFilter({
                                    ignoreCase:true,
                                    ignoreAccents:true,
                                    trim:true,
                                    matchFrom:'start'
                                  })}
                                onBlur={this.hideMenu}
                                onFocus={this.hideMenu}
                                menuIsOpen={this.state.showDropDown}
                                onInputChange={(query, { action }) => {
                                    if (action === "input-change") {
                                        if((query||'').trim().length>0){
                                            this.setState({ showDropDown: true });
                                        }else{
                                            this.setState({ showDropDown: false });
                                        }
                                    }
                                    else if(action==="input-blur" || action==="set-value"){
                                        this.setState({ showDropDown: false });
                                    }
                                }}
                                // closeMenuOnSelect={true}
                                className="basic-single"
                                classNamePrefix="select"
                                isClearable={true}
                                isSearchable={true}
                                options={this.state.schoolList.map((_school)=>{
                                    return {value:_school.schoolName,label:_school.schoolName, rec:_school}
                                })}
                                onChange={(option)=>{
                                    if(option){
                                        let _schoolInfo=this.state.schoolInfo;
                                        _schoolInfo.id=Number(option.rec.schoolId);
                                        _schoolInfo.name=option.label;
                                        _schoolInfo.sessionYear=(option.rec||{}).schoolYear||'';
                                        _schoolInfo.schoolPdfUrl=(option.rec||{}).schoolPdfUrl||'';
                                        this.setState({schoolInfo:_schoolInfo})
                                      }else{
                                        let _schoolInfo=this.state.schoolInfo;
                                        _schoolInfo.id=0;
                                        _schoolInfo.name='';
                                        _schoolInfo.sessionYear='';
                                        _schoolInfo.schoolPdfUrl='';
                                        this.setState({schoolInfo:_schoolInfo})
                                      }
                                }}
                                />
                            {/* <SchoolSelect 
                              schoolList={this.state.schoolList.map((_school)=>{return _school.schoolName})}
                              onSelectSchool={(item)=>{
                                let idx=this.state.schoolList.findIndex((school)=>{
                                  return school.schoolName===item
                                })
                                if(idx!==-1){
                                  let _schoolInfo=this.state.schoolInfo;
                                  _schoolInfo.id=this.state.schoolList[idx].schoolId;
                                  _schoolInfo.name=this.state.schoolList[idx].schoolName;
                                  _schoolInfo.sessionYear=this.state.schoolList[idx].schoolYear;
                                  _schoolInfo.schoolPdfUrl=this.state.schoolList[idx].schoolPdfUrl;
                                  this.setState({schoolInfo:_schoolInfo})
                                }else{
                                  let _schoolInfo=this.state.schoolInfo;
                                  _schoolInfo.id=0;
                                  _schoolInfo.name='';
                                  _schoolInfo.sessionYear='';
                                  _schoolInfo.schoolPdfUrl='';
                                  this.setState({schoolInfo:_schoolInfo})
                                }
                              }} onClickNext={()=>{
                                if((this.state.schoolInfo.id||0)==0){
                                  _addNotificationError(`Please select ${this.state.districtStatus==='DISTRICT'?'District':'School'}.`, this);                                
                                }else{
                                  this.setState({showStepWizard:true});
                                }
                              }} /> */}                              
                          </div>
                          <div className='col-md-1 col-xs-12  form-group'>
                            <button className='btn btn-success' style={{margin:'0px', width:'100%'}} onClick={()=>{
                                if((this.state.schoolInfo.id||0)==0){
                                  _addNotificationError(<Trans>{`Please select ${this.state.districtStatus?'District':'School'}`}</Trans>, this);                                
                                }else{
                                  this.setState({showStepWizard:true});
                                }
                              }} ><i className='fa fa-arrow-right'></i></button>
                          </div>                          
                        </div>)
                        }
                    </div>
                                <div className="col-md-12">
                                    <div className="faqsidebar" id="faqsidebar">
                                        <div className="toggle" id="faqsidebar_close" onClick={()=>{
                                            this.showHidefaqsidebar()
                                        }}></div>
                                        <h3>Help</h3>
                                        <div className="scroll">
                                            <FreeReducedProgramFAQ  schoolInfo={this.state.schoolInfo} schoolList={this.state.schoolList}/>                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </Fragment>)
    }
}
export default translate("translations")(FreeReducedProgram);


// WEBPACK FOOTER //
// ./src/components/FreeReducedProgram/index.jsx